import translator from '@Components/Utilities/Translator';
import Modal from '@Components/Shared/Modals/Modal';
import { truncateString } from '@Components/Utilities/SandhillsUtility';
import { useWindowSize } from '@Components/Utilities/WindowSize';

const DealerLocationsModal = (props) => {
    const windowSize = useWindowSize();

    const onClose = () => {
        props.toggleModal();
    };

    const truncateName = (name) => {
        return truncateString(name, windowSize.isMobile ? 45 : 80);
    };

    return (
        <Modal containerClassName='dealer-locations-modal ts-modal-container' onEscapeKeyClose={onClose}>
            <Modal.Header onClose={onClose}>
                <Modal.Title>
                    {translator.translate('sandhills.tradesites.mvc.variouslocations')}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {props.Locations.map((location, index) => {
                    return (<a key={location.LocationID} className='dealer-location' href={location.DealerLocationURL}>{location.DealerName}</a>)
                })}
                <div className='modal-footer'>
                    <div className='close-button'>
                        <button onClick={onClose}>{translator.translate('sandhills.closepage')}</button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default DealerLocationsModal;